module.exports = __webpack_public_path__ + "img/mbg.26d6a07e.png";